import { Alerts } from "../../../utils/Alerts.js";
import { AuthViewModel } from "../../AuthWrapper2/viewmodels/AuthViewModel.js";
import { RegionViewModel } from "../viewmodels/RegionViewModel.js";
import { AppShellViewModel } from "../viewmodels/AppShellViewModel.js";
import { SidePanelViewModel } from "../viewmodels/SidePanelViewModel.js";
import { BrowserCheck } from "../../../components/BrowserCheck/index.js";
import { NotificationToasts } from "../../Notifications/components/NotificationToasts.js";
import { AppShell } from "./AppShell.js";
import { DownloadsAuthSync } from "./DownloadsAuthSync.js";
import { DownloadsRegionSync } from "./DownloadsRegionSync.js";
import { OfflineToast } from "./OfflineToast.js";
/* empty css                 */
import { useEffect } from "react";
import { Toast, toastManager } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { useEvent, useSingleton } from "mvc-kit/react";
//#region src/modules/AppWrapper2/components/AppShellBootstrap.tsx
function AppShellBootstrap({ allowMultiRegionSelection, appInteractionHandlers, appURLOverride, children, currentAppId, currentAppOverride, mapboxToken, onIdentityChanged, onLogout, onRegionChanged, scopeAllRegions }) {
	const shellVM = useSingleton(AppShellViewModel);
	const regionVM = useSingleton(RegionViewModel, {
		...RegionViewModel.DEFAULT_STATE,
		allowMultiRegionSelection: allowMultiRegionSelection ?? false,
		scopeAllRegions: scopeAllRegions ?? false
	});
	const authVM = useSingleton(AuthViewModel);
	useSingleton(SidePanelViewModel);
	useEffect(() => {
		regionVM.configure({
			allowMultiRegionSelection: allowMultiRegionSelection ?? false,
			scopeAllRegions: scopeAllRegions ?? false
		});
	}, [
		allowMultiRegionSelection,
		regionVM,
		scopeAllRegions
	]);
	useEffect(() => {
		shellVM.syncConfig({
			appInteractionHandlers: appInteractionHandlers ?? null,
			appURLOverride: appURLOverride ?? null,
			currentAppId,
			currentAppOverride: currentAppOverride ?? null,
			mapboxToken: mapboxToken ?? ""
		});
	}, [
		appInteractionHandlers,
		appURLOverride,
		currentAppId,
		currentAppOverride,
		mapboxToken
	]);
	useEvent(regionVM, "regionChanged", (region) => {
		onRegionChanged?.(region);
	});
	useEvent(authVM, "identityChanged", (identityInfo) => {
		onIdentityChanged?.(identityInfo);
	});
	useEvent(authVM, "loggedOut", ({ appName }) => {
		onLogout?.();
		const link = appName ? `/${appName.toLowerCase()}` : "";
		location.replace(location.origin + link);
	});
	useEvent(authVM, "changeUserFailed", ({ appName, errorMessage }) => {
		Alerts.error("There was a problem switching profiles", errorMessage, { onClose: () => {
			const link = appName ? `/${appName.toLowerCase()}` : "";
			location.replace(location.origin + link);
		} });
	});
	useEvent(authVM, "godModeTokenApplied", () => {
		toastManager(/* @__PURE__ */ jsx(Toast, {
			hideCloseButton: true,
			children: /* @__PURE__ */ jsx("div", {
				className: "text-center",
				children: "Resetting authentication - using new auth token for session."
			})
		}), {
			autoClose: 3e3,
			position: toastManager.POSITION.TOP_CENTER,
			type: "info",
			variant: "info"
		});
	});
	if (!shellVM.identityInfo) return null;
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [
		/* @__PURE__ */ jsx(BrowserCheck, {}),
		/* @__PURE__ */ jsx(NotificationToasts, {}),
		/* @__PURE__ */ jsx(OfflineToast, {}),
		/* @__PURE__ */ jsx(DownloadsAuthSync, {}),
		/* @__PURE__ */ jsx(DownloadsRegionSync, {}),
		/* @__PURE__ */ jsx(AppShell, { children })
	] });
}
//#endregion
export { AppShellBootstrap };

//# sourceMappingURL=AppShellBootstrap.js.map